var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cst-upload"},[_c('van-uploader',{attrs:{"max-count":_vm.maxCount,"file-list":_vm.fileList,"after-read":_vm.onAfterRead},on:{"delete":_vm.deleteFile}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }